import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;

    .search-bar{
        margin: 20px 0px;
    }

    .floating-button{
        position: fixed;
        z-index: 2000;
        right: 1%;
    }

    .search-form{
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
    }

`
